import _ from 'lodash'

let dateOperators = ['between-date-time', 'after', 'before', 'in-period']

/**
 * Returns whether any of the provided filters are for relative dates
 */
function hasRelativeDateFilter(filters) {
	return _.find(filters, filter => {
		let hasDateOperator = _.includes(dateOperators, filter.operator)
		let hasPeriodDelta =
			!_.isNil(filter.periodDelta1) || !_.isNil(filter.periodDelta2)
		if (hasDateOperator && hasPeriodDelta) {
			return true
		}
	})
}

export default hasRelativeDateFilter

hasRelativeDateFilter.__filename__ = 'datasets/has-relative-date-filter.js'
